var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.icons),function(i){return _c('img',{key:i,class:_vm.selected === i ? 'selected' : null,attrs:{"src":require('@/assets/icons/' + i)},on:{"click":function($event){_vm.selected = i;
      _vm.$emit('select', i);}}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }